import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import vuedraggable from 'vuedraggable'; // 一款vue拖拽插件

import lrz from 'lrz'; // 一款图片压缩插件

import utils from '@/libs/util.upload';
export default {
  name: 'ImgUpload',
  props: {
    // 图片数据(图片url组成的数组) 通过v-model传递
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 限制上传的图片数量
    limit: {
      type: Number,
      default: 99
    },
    // 限制上传图片的文件大小(kb)
    size: {
      type: Number,
      default: 500
    },
    // 是否是单图上传(单图上传就是已传图片和上传按钮重叠)
    isSingle: {
      type: Boolean,
      default: false
    },
    // 是否使用图片压缩
    useCompress: {
      type: Boolean,
      default: false
    },
    // 是否是产品细节图列表
    tradeList: {
      type: Boolean,
      default: false
    },
    // 图片显示的宽度(px)
    width: {
      type: Number,
      default: 100
    },
    // 图片显示的高度(px)
    height: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      headers: {},
      isUploading: false,
      // 正在上传状态
      isFirstMount: true // 控制防止重复回显

    };
  },
  computed: {
    // 图片数组数据
    imgList: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (val.length < this.imgList.length) {
          // 判断是删除图片时同步el-upload数据
          this.syncElUpload(val);
        } // 同步v-model


        this.$emit('input', val);
      }
    },
    // 控制达到最大限制时隐藏上传按钮
    isMaxHidden: function isMaxHidden() {
      return this.imgList.length >= this.limit;
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (this.isFirstMount && this.value.length > 0) {
          this.syncElUpload();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    if (this.value.length > 0) {
      this.syncElUpload();
    }
  },
  methods: {
    // 同步el-upload数据
    syncElUpload: function syncElUpload(val) {
      var imgList = val || this.imgList;
      this.$refs.uploadRef.uploadFiles = imgList.map(function (v, i) {
        return {
          name: 'pic' + i,
          url: v,
          status: 'success',
          uid: utils.createUniqueString()
        };
      });
      this.isFirstMount = false;
    },
    // 上传图片之前
    beforeUpload: function beforeUpload(file) {
      var _this = this;

      this.isFirstMount = false;

      if (this.useCompress) {
        // 图片压缩
        return new Promise(function (resolve, reject) {
          lrz(file, {
            width: 1920
          }).then(function (rst) {
            file = rst.file;
          }).always(function () {
            if (utils.validImgUpload(file, _this.size)) {
              _this.isUploading = true;
              resolve();
            } else {
              reject(new Error());
            }
          });
        });
      } else {
        if (utils.validImgUpload(file, this.size)) {
          this.isUploading = true;
          return true;
        } else {
          return false;
        }
      }
    },
    // 上传完单张图片
    onSuccessUpload: function onSuccessUpload(res, file, fileList) {
      if (res.files) {
        if (this.imgList.length < this.limit) {
          this.imgList.push(res.files.file);
        }
      } else {
        this.syncElUpload();
        this.$notify.error({
          title: '失败',
          message: res.msg
        });
      }

      this.isUploading = false;
    },
    // 移除单张图片
    onRemoveHandler: function onRemoveHandler(index) {
      var _this2 = this;

      this.$confirm('确定删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.imgList = _this2.imgList.filter(function (v, i) {
          return i !== index;
        });
      }).catch(function () {});
    },
    // 超限
    onExceed: function onExceed() {
      this.$refs.uploadRef.abort(); // 取消剩余接口请求

      this.syncElUpload();
      this.$notify.warning({
        title: '警告',
        message: "\u56FE\u7247\u8D85\u9650\uFF0C\u6700\u591A\u53EF\u4E0A\u4F20".concat(this.limit, "\u5F20\u56FE\u7247")
      });
    },
    onDragStart: function onDragStart(e) {
      e.target.classList.add('hideShadow');
    },
    onDragEnd: function onDragEnd(e) {
      e.target.classList.remove('hideShadow');
    }
  },
  components: {
    vuedraggable: vuedraggable
  }
};